module.exports = __webpack_public_path__ + "img/lg.590aa812.png";